module.exports = __webpack_public_path__ + "img/cz@2x.dc5c3db2.png";